<label v-onresize="onResize" :data-card="dataCard" v-html="content"></label>